export function waitForElementToDisappear(elementQuery) {
  const element = document.querySelector(elementQuery);
  if (!element) {
    return Promise.resolve();
  }
  return new Promise(resolve => {
    const observer = new MutationObserver(() => {
      const el = document.querySelector(elementQuery);
      if (!el) {
        resolve();
        observer.disconnect();
      }
    });
    observer.observe(document, {
      attributes: true,
      childList: true,
      characterData: false,
      subtree: true
    });
  });
}